<template>
		<v-card class="mt-4">
			<v-progress-linear v-if="loading" indeterminate />
			<v-simple-table>
				<tbody>
					<tr>
						<th class="text-center">상품권 이름</th>
						<th class="text-center">플랫폼</th>
						<th class="text-center">액면가</th>
						<th class="text-center">판매가</th>
						<!-- <th class="text-center">수수료[모바일](원)</th> -->
						<!-- <th class="text-center">actions</th> -->
					</tr>
					<tr>
						<td class="text-center">
							<v-layout align-center>
								{{ giftcard.name }}
							</v-layout>
						</td>
						<td class="text-center">{{ giftcard.platform }}</td>
						<td class="text-center">
							{{ giftcard?.faceamt?.format?.() }}원
						</td>
						<td class="text-center">
							{{ giftcard?.faceamt?.format?.() }}원
						</td>
						<!-- <td class="text-center">
							<span>
								{{ (Math.floor(option.salePrice * giftcard.commission.mobile / (1000 * giftcard.commission.cutUnit)) * giftcard.commission.cutUnit * 10)?.format?.() }}원
							</span>
						</td> -->
						<!-- <td class="text-center">
							<v-btn :disabled="!scope.includes('root')" color="white" class="px-1 mr-1 primary--text" width="36" height="36" style="min-width: auto" @click="$emit('remove')"><v-icon>mdi-minus</v-icon></v-btn>
						</td> -->
					</tr>
				</tbody>
			</v-simple-table>

			<v-divider />

			<v-card-title>
				<v-layout align-center>
					<span class="subtitle-2"><b>핀 재고 목록 (미발행: {{ summary?.unIssuedCount?.format?.() }}건, 발행완료: {{ summary?.issuedCount?.format?.() }}건, 취소완료: {{ summary?.canceledCount?.format?.() }}건)</b></span>
					<v-spacer/>
					<v-btn color="green" outlined height="36" class="my-auto mr-2" @click="excel">
						<v-icon left>{{ mdiMicrosoftExcel }}</v-icon>
						<span>엑셀 핀 다운로드</span>
					</v-btn>
					<v-btn color="green" outlined height="36" class="my-auto mr-2" @click="$refs.uploadDialog.open()">
						<v-icon left>{{ mdiMicrosoftExcel }}</v-icon>
						<span>엑셀 핀 업로드</span>
					</v-btn>
				</v-layout>
			</v-card-title>

			<v-divider/>

			<v-data-table v-model="selected" item-key="_id" show-select checkbox-color="red lighten-1" :items="pins || []" :headers="pinsHeaders">
				<template v-slot:item.faceamt="{ item }">
					{{ item?.faceamt?.format?.() }}
				</template>
				<template v-slot:item.createdAt="{ item }">
					{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
				</template>
				<template v-slot:item.issuedAt="{ item }">
					{{ item.issuedAt ? $dayjs(item.issuedAt).format("YYYY-MM-DD HH:mm:ss") : "-" }}
				</template>
				<template v-slot:item.canceledAt="{ item }">
					{{ item.canceledAt ? $dayjs(item.canceledAt).format("YYYY-MM-DD HH:mm:ss") : "-" }}
				</template>
				<template v-slot:footer.prepend>
					<v-btn color="red lighten-2" outlined @click="remove()"><v-icon left>mdi-delete-outline</v-icon>미발행 선택삭제</v-btn>
				</template>
			</v-data-table>
			<upload-dialog ref="uploadDialog" @input="upload" />
		</v-card>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import UploadDialog from "@/components/console/shop/giftcards/upload-dialog.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
	components: {
		UploadDialog,
	},
	props: {
		giftcard: { type: Object }
	},
	data() {
		return {
			mdiMicrosoftExcel,
			selected: [],
			pins: [],

			loading: false,

			summary: { totalCount: 0 },
			pinsHeaders: [
				{ text: "상품권 이름", value: "name", align: "center", width: 200 },
				{ text: "핀번호", value: "pno", align: "center", width: 200 },
				{ text: "인증번호", value: "certificationNo", align: "center", width: 200 },
				{ text: "발행일자", value: "issueNo", align: "center", width: 200 },
				{ text: "관리번호", value: "managementNo", align: "center", width: 200 },
				{ text: "액면가", value: "faceamt", align: "center", width: 150 },
				{ text: "상태", value: "status", align: "center", width: 150 },
				{ text: "등록일자", value: "createdAt", align: "center", width: 200 },
				{ text: "발행일자", value: "issuedAt", align: "center", width: 200 },
				{ text: "취소일자", value: "canceledAt", align: "center", width: 200 },
			],
		}
	},
	methods: {
		async init(){
            let { summary, pins } = await api.console.shop.giftcards.pins.gets(this.$route.params._giftcard, {
                // params: {
                //     status: "미발행"
                // }
            });
            this.summary = summary;
			this.pins = pins;
        },
		async upload(pins){
			this.loading = true;
            for(let pin of pins){
                if(+pin.faceamt == +this.giftcard.faceamt) await api.console.shop.pins.post({ ...pin, _giftcard: this.$route.params._giftcard });
            }
			this.loading = false;
            if(pins?.length) alert("엑셀이 업로드 되었습니다");

            this.init();
            this.$emit("pins");
        },

        async remove(){
            if(confirm("삭제하시겠습니까?")){
                for(let pin of this.selected){
                    await api.console.shop.pins.delete(pin);
                }
                
                this.selected = [];
                this.init();
                this.$emit("pins");
            }
        },
		async excel(){
			let { pins } = await api.console.shop.giftcards.pins.gets(this.$route.params._giftcard, {})

            var datas = [];
            pins.forEach(pin => {
                datas.push({
                    "상품권 이름": pin?.name,
                    "핀번호": pin?.pno,
					"인증번호(도서문화상품권)": pin?.certificationNo,
					"발행일자(해피머니)": pin?.issueNo,
                    "관리번호(해피머니)": pin?.managementNo,
					"액면가": pin?.faceamt?.format?.(),
                    "상태": pin?.status,
					"등록일자": pin?.createdAt ? this.$dayjs(pin?.createdAt).format("YYYY-MM-DD HH:mm:ss") : "-",
					"발행일자": pin?.issuedAt ? this.$dayjs(pin?.issuedAt).format("YYYY-MM-DD HH:mm:ss") : "-",
					"취소일자": pin?.canceledAt ? this.$dayjs(pin?.canceledAt).format("YYYY-MM-DD HH:mm:ss") : "-"
                });
            });

            var workbook = new XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(datas);

            XLSX.utils.book_append_sheet(workbook, worksheet, "핀번호 목록");
            XLSX.writeFile(workbook, "핀번호 목록.xlsx");
        }
	},
	async mounted() {
		await this.init();
	}
}
</script>

<style>

</style>